import styled from 'styled-components';
import { colorUsage, getSpacing, pageWidth, shadow } from 'stylesheet';
var Paper = styled.div.withConfig({
  displayName: "Paper",
  componentId: "sc-1719k6j-0"
})(["width:100%;max-width:", "px;padding:", " ", ";background-color:", ";box-shadow:", ";"], function (props) {
  return props.size === 'small' ? pageWidth.small : pageWidth.large;
}, getSpacing(4), getSpacing(6), colorUsage.pageForeground, shadow.bottom.dark);
export default Paper;